const menuGrupo = {
    PEDIDOS: 3,
    BILINGUE: 1,
    IJ: 2,
    CFE: 4,

    desc: (value) => {
        switch(value){
            case 1:
                return 'Perto Bilíngue';
            
            case 2:
                return 'Inglês Juntos';

            case 3:
                return 'Pedidos';

            case 4:
                return 'Controle Financeiro Escolar'

            default: return value;

        }
    }
}

export default menuGrupo;